
import { formatNumber } from '../../assets/js/utils/math'
import DownloadOverlayButton from './DownloadOverlayButton'
import LocaleChanger from './LocaleChanger'
import AppProductBadge from '~/components/atoms/AppProductBadge'

export default {
  name: 'OverlayDetails',
  components: { LocaleChanger, DownloadOverlayButton, AppProductBadge },
  props: {
    theme: { type: Object, default: () => {} },
    download: { type: Boolean, default: false }
  },
  data () {
    return {
      selectedScreen: 1,
      language: 'en'
    }
  },
  computed: {
    likedButton () {
      return this.liked === true
        ? this.$asset('/assets/images/icons/thumbs_filled.svg')
        : this.$asset('/assets/images/icons/thumbs.svg')
    },
    dislikedButton () {
      return this.liked === false
        ? this.$asset('/assets/images/icons/thumbs_filled.svg')
        : this.$asset('/assets/images/icons/thumbs.svg')
    },
    selectedElement () {
      if (Array.isArray(this.screens)) {
        return this.screens.find(screen => screen.id === this.selectedScreen) || null
      }

      return null
    },
    styleCategories () {
      if (this.theme && this.theme.style_categories && this.theme.style_categories.length > 0) {
        return this.theme.style_categories.map(s => s.name).slice(0, 3).join(' • ')
      }

      return null
    },
    eventCategory () {
      if (this.theme && this.theme.event_categories && this.theme.event_categories.length > 0) {
        return this.theme.event_categories[0].name
      }

      return null
    },
    availableLanguages () {
      if (!this.theme.assets) {
        return null
      }

      return this.theme.assets.map(asset => asset.locale)
    },
    liked () {
      return this.$store.getters['like/getLiked'](this.theme.id)
    },
    availableScreens () {
      if (!this.theme || !this.theme.screens) {
        return null
      }

      const screenTypes = {}

      for (const screen of this.theme.screens) {
        if (!screenTypes[screen.id]) {
          screenTypes[screen.id] = {}
        }

        screenTypes[screen.id][screen.pivot.locale || 'default'] = screen
      }

      return screenTypes
    },
    screens () {
      if (!this.availableScreens) {
        return []
      }

      const screens = []

      for (const key of Object.keys(this.availableScreens)) {
        const screen =
          // load selected theme locale screen
          this.availableScreens[key][this.language] ||
          // load "en" screen as fallback
          this.availableScreens[key].en ||
          // load "default" screen as last fallback
          this.availableScreens[key].default

        if (screen) {
          screens.push(screen)
        }
      }

      return screens
    }
  },
  created () {
    if (this.availableLanguages.includes(this.$i18n.locale)) {
      this.language = this.$i18n.locale
    }
  },
  methods: {
    formatNumber,
    like (like) {
      this.$store.dispatch('like/likeTheme', { themeId: this.theme.id, liked: like })
    },
    selectVideo (index) {
      this.selectedScreen = index

      this.$nextTick(() => {
        this.$refs.video.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
      })
    }
  }
}
